import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';

import { CardOriginFundType } from '../types/MovimentacaoFundosType';
import { formatMoney } from '../utils/formatMoney';

export const CardOrigin = ({
  originFundValueUpdated,
  originFundValuePercentage,
  handleDecrementPercentage,
  handleIncrementPercentage,
  handleInputChangeOriginFund,
  parentRef
}: CardOriginFundType) => {
  const validatePercentage = (event: any) => {
    let parsedValue = parseFloat(event.target.value);

    if (event.key === 'Backspace') {
      parsedValue = 0;
    }

    if (isNaN(parsedValue) || parsedValue > 100) {
      parsedValue = 100;
    }
    handleInputChangeOriginFund(parsedValue);
  };

  return (
    <div className="tw-w-full tw-max-w-[320px] tw-mt-10 tw-rounded-lg">
      <div className="tw-p-4 tw-bg-[#FA6B25] tw-text-white tw-font-bold tw-rounded-t-lg tw-border-2 tw-border-orange-500 tw-text-center">
        Origem
      </div>
      <div className="tw-border-b-2 tw-border-l-2 tw-border-r-2 tw-border-gray-300 tw-rounded-b-lg">
        <div className="tw-p-4 tw-flex tw-items-center tw-justify-between">
          <span>Saldo do fundo:</span>
          <span className="tw-text-[#006217] tw-text-[1rem] tw-leading-[1.5rem] tw-font-bold">
            {formatMoney(originFundValueUpdated.toFixed(2))}
          </span>
        </div>
        <div
          ref={parentRef}
          className="tw-p-4 tw-bg-[#F3F3F3] tw-rounded-b-lg tw-flex tw-items-center tw-justify-between"
        >
          <span>% de transferência</span>
          <div className="tw-flex tw-items-center tw-w-[98px] tw-h-[42px] tw-bg-white tw-border-2 tw-border-[#001E64] tw-rounded-[6px]">
            <input
              type="number"
              className="input-percentual-fundo tw-p-[6px] tw-w-full tw-h-full tw-rounded-[6px] tw-outline-none"
              placeholder="%"
              value={
                originFundValuePercentage > 0 ? originFundValuePercentage : ''
              }
              onChange={(event) => {
                validatePercentage(event);
              }}
              onKeyDown={(event) => {
                if (event.key === 'Backspace') {
                  validatePercentage(event);
                }
                if (event.key === '.' || event.key === ',') {
                  event.preventDefault();
                }
              }}
            />
            <div className="tw-flex tw-flex-col tw-justify-center tw-mr-1 tw-items-center">
              <button
                data-testid="button-increment"
                onClick={() =>
                  handleIncrementPercentage(originFundValuePercentage, 'origin')
                }
              >
                <TriangleUpIcon color="#1B365D" w="10px" h="7px" />
              </button>
              <button
                data-testid="button-decrement"
                onClick={() =>
                  handleDecrementPercentage(originFundValuePercentage, 'origin')
                }
              >
                <TriangleDownIcon color="#1B365D" w="10px" h="7px" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
